<script lang="ts">
    import MedialibFile from "../../MedialibFile.svelte"

    export let column: BlockColumn<"introductionText">
    export let brightBg = false
    const iT = column.introductionText
</script>

<div class="wrapper-intro" class:brightBg>
    <div class="border-bottom-bold upper">
        {@html iT.shortDescription || ""}
    </div>
    <div class="lower">
        <div>
            {@html iT.description || ""}
        </div>
        {#if !!iT.emphazisedDetails}
            <div class="block">
                <span class="img">
                    <MedialibFile id="{iT.emphazisedDetails.icon}" let:src>
                        <img {src} alt="icon" />
                    </MedialibFile>
                </span>

                <span>
                    {@html iT.emphazisedDetails.description || ""}
                </span>
            </div>
        {/if}
    </div>
</div>

<style lang="less">
    .wrapper-intro:global {
        display: flex;
        flex-direction: column;
        color: var(--white-100) !important;

        div,
        *,
        p {
            color: var(--white-100) !important;
        }
        .upper {
            padding: 24px 0px;
            width: 100%;
            border-bottom: 4px solid var(--white-100);
            font-size: 1.2rem;
            line-height: 140%;
            * {
                font-size: 1.2rem !important;
            }
        }
        .lower {
            padding-top: 24px;
            display: flex;
            width: 100%;
            flex-direction: column;
            gap: 32px;
            font-size: 0.9rem;
            div {
                width: 100%;
            }
            .block {
                border: 1px solid var(--white-100);
                border-radius: 2px;
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 12px;
                max-width: calc(100% - 24px);
                width: 100%;
                span.img {
                    width: 56px;
                    height: 56px;
                    img {
                        height: 100%;
                        object-fit: contain;
                    }
                }
                span:last-of-type {
                    flex-grow: 1;
                }
            }
        }
    }
    .wrapper-intro.brightBg:global {
        color: var(--grey-100) !important;
        border-color: var(--grey-100) !important;

        div,
        *,
        p {
            color: var(--grey-100) !important;
            border-color: var(--grey-100) !important;
        }
    }
</style>
